import React from 'react'
import { Grid, Typography, Link } from '@mui/material'
import { useExternalApp } from '../../hooks'
import Container from '../container'

const NotAuthorized = props => {
  const { getMtUrl } = useExternalApp()
  return (
    <Container maxContentWidth={1200} inset={3}>
      <Grid container direction='column' alignItems='center'>
        <Typography
          variant='h6'
          paragraph
          align='center'
          data-test='not-authorized-title'
        >
          Sorry, you are not authorized to access this resource
        </Typography>
        <Typography align='center' data-test='not-authorized-text'>
          To gain access, you should{' '}
          <Link
            href={getMtUrl('join')}
            underline='always'
            data-test='not-authorized-action-join'
          >
            join Mind Tools
          </Link>
        </Typography>
      </Grid>
    </Container>
  )
}

export default NotAuthorized
